import { render, staticRenderFns } from "./HelloServicios.vue?vue&type=template&id=95a805f2"
import script from "./HelloServicios.vue?vue&type=script&lang=js"
export * from "./HelloServicios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports